module.exports = "<p>\n  transaction works!\n</p>\n"